<template>
	<div class="FilterList">
		<CheckBoxSelectItem
			v-for="item in items"
			:key="item.value"
			:item="item"
			@selectionChange="(state) => handleSelectionChange(item, state)"
		/>
	</div>
</template>

<script setup lang="ts">
import CheckBoxSelectItem from '@components/CheckBoxSelectItem/CheckBoxSelectItem.vue';
import { DurationFilterMapper } from '@app/routing/mappers/DurationFilterMapper';
import { useCheckboxFilter } from '@composables/useCheckboxFilter';
import { FilterType } from '@domain/enums/FilterType';

const { items, handleSelectionChange } = useCheckboxFilter(
	DurationFilterMapper.getInstance(),
	FilterType.DURATION
);
</script>

<style scoped lang="scss">
.FilterList {
	width: 100%;
	padding-right: 2px;	// required for outline not to be cut off
}
</style>
